export default __webpack_public_path__ + "static/media/img-0727-latvia-full-face.f95ba4fa.png";